import * as React from "react";
import {Api} from "../../lib/Api";
interface IConfirmOrderProps {
    professional: any
    user        : any
    successResponse: Function

    startDateTime: any
    endDateTime: any
    hours: any
    description: any
    photo: any
}

interface IConfirmOrderState{

}


export default class ConfirmOrder extends React.Component<IConfirmOrderProps, IConfirmOrderState> {

    constructor(props: IConfirmOrderProps) {
        super(props);
        this.state = {};

    }

    private orderDateTime(){

        let result = this.props.startDateTime.toLocaleDateString("en-US", { month: 'short', day: 'numeric' })+', '+this.props.startDateTime.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        });
        result+= ' - ';

        if(this.props.startDateTime.getDate() != this.props.endDateTime.getDate()){
            result += this.props.endDateTime.toLocaleDateString("en-US", { month: 'short', day: 'numeric' }) + ', ';
        }

        result += this.props.endDateTime.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        });

        return result;

    }

    private submitOrder(){
        Api.call('/user/order/saveOrder', {
            offerId: this.props.professional.id,
            startDateTime: this.props.startDateTime,
            endDateTime: this.props.endDateTime,
            hours: this.props.hours,
            photo: this.props.photo,
            description: this.props.description
        }, (result) =>{
            if(result.status == "success") {
                this.props.successResponse();
            }
        });
    }

    render() {
            return (
            <div className = "confirm_order">
                <h1>Your professional:</h1>

                <div className="content_row">
                    <div className = "image">
                        {
                            this.props.user.photos?.profilePhoto.length > 0 &&
                            <img src={this.props.user.photos?.profilePhoto} />
                        }
                    </div>

                    <div className = "content">
                        <p className = "name">{this.props.user.name}</p>
                        {
                            this.props.user.rateing > 0 &&
                            <span className="rateing_star_inline_box">
                                { this.props.user.rateing >= 1?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                { this.props.user.rateing >= 2?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                { this.props.user.rateing >= 3?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                { this.props.user.rateing >= 4?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                { this.props.user.rateing >= 5?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                </span>
                        }
                    </div>
                </div>

                <div className = "confirm_order_content">
                    <p className = "good-choice-text">Good choice!</p>
                    <div className = "box">
                        <img src = {this.props.professional.offerType.img}/>
                        <p className = "professional_name">{this.props.professional.offerType.name}</p>
                        <p className = "professional_select_date">
                            {this.orderDateTime()}
                        </p>
                        <p className = "professional_price"> { this.props.professional.price * this.props.hours } { this.props.professional.currency }</p>
                    </div>
                </div>

                <div className = "order-btn">
                    <button type="button" className="purple_btn" onClick={() => this.submitOrder()}>I order</button>
                    <a className = "terms" href = "#">General terms and conditions</a>
                </div>

                <div className = "back-btn">
                    <button type="button" className="back_btn">Back to the services</button>
                </div>
            </div>
        );
    };
}
